import React from 'react'
import TableWidget3 from './TableWidget3'
import products from '../json/products.json'

const SampleTableWidget3 = () => <TableWidget3 items={products} />

export default SampleTableWidget3
